module.exports = __webpack_public_path__ + "img/fastapi.102c66c4.svg";